import { Message } from 'element-ui'
import router from '@/router/router'
import { getLangDict } from '@/utils/getLangDict'
import Storage from '@/utils/storage'

const langDict = getLangDict();

const Service = {};     // 构造API对象

// 需要全局处理的错误编码
const needHandleCode = [
    20001002, 20001003, 
    30001001, 30001002, 30001003, 
    40001001, 40001002, 40001003, 40001004, 
    40001005, 40001006, 40011001, 40011002,
    50001001, 50001002, 50001003
];

// 错误提示
Service.message = (() => {
    // 报错数量
    let num = 0;
    return {
        error: (msg, time=3, callBack) => {
            if (num === 0) {
                Message.error({
                    message: msg,
                    duration: time*1000,
                    onClose: function() {
                        if (typeof callBack == 'function') {
                            callBack();
                        }
                        if (num > 0) num--;
                    }
                });
                num++;
            }
        }
    };
})();

// 跳转页面
Service.goPath = function (path) {
    if(!path) return;
    router.push(path)
}

// 获取项目ID
Service.getProjectId = function() {
    if (Storage.get('PROJECT_OID')) {
        return Storage.get('PROJECT_OID').project_oid;
    } else {
        this.message.error('项目ID不存在', 2, ()=>{
            Service.goPath('/projectlist');    // 不存在项目ID就跳转首页
        });
        return false
    }
}

//获取项目子系统id
Service.getProjectSystemId = function() {
    if (Storage.get('SYSTEM_OID')) {
        return Storage.get('SYSTEM_OID').system_oid;
    } else {
        this.message.error('项目子系统ID不存在', 2, ()=>{
            Service.goPath('/projectsystemlist');    // 不存在项目ID就跳转首页
        });
        return false
    }
}

Service.handleCommonError = function (data) {
    if(!data.status) return;
    if (data.status == 20001000){
        return data.data || 'success'
    } else if (parseInt(data.status) == 20001002){
        this.message.error("登录过期", 2, () => {
            // Service.goPath('/login');
            location.href = '/login'
        });
    } else {
        if ((needHandleCode.indexOf(data.status) > -1)) {
            // 错误码提示错误
            let errorStr = langDict.globalCode[data.status]
            this.message.error(errorStr, 3);
        }else{
            // 后端返回错误
            this.message.error(data.messages, 3);
        }
    }
}

export default Service